import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
    :root {
        --primary-color: #EE3B24;
        --secundary-color: #F7A51B;
        --auxiliary-color: #4D4D4D;
        --grey-color: #E7E3DE;
        --grey-dark-color: #595959;
        --white: #FFF;
        --light: #f9f9f9;
        --dark: #343a40;
        --breakpoint-xs: 0;
        --breakpoint-sm: 576px;
        --breakpoint-md: 768px;
        --breakpoint-lg: 992px;
        --breakpoint-xl: 1200px;
    }

    @font-face {
        font-family: "PFSquareSansProBold";
        src: url(${
			require("@/assets/fonts/PFSquareSansPro/PFSquareSansProBold_35480.ttf")
				.default
		}) format("truetype");
    }

    @font-face {
        font-family: "PFSquareSansProBoldItalic";
        src: url(${
			require("@/assets/fonts/PFSquareSansPro/PFSquareSansProBoldItalic_35481.ttf")
				.default
		}) format("truetype");
    }
    
    @font-face {
        font-family: "PFSquareSansProExtraBlack";
        src: url(${
			require("@/assets/fonts/PFSquareSansPro/PFSquareSansProExtraBlack_35482.ttf")
				.default
		}) format("truetype");
    }

    @font-face {
        font-family: "PFSquareSansProExtraBlackItalic";
        src: url(${
			require("@/assets/fonts/PFSquareSansPro/PFSquareSansProExtraBlackItalic_35483.ttf")
				.default
		}) format("truetype");
    }

    @font-face {
        font-family: "PFSquareSansProItalic";
        src: url(${
			require("@/assets/fonts/PFSquareSansPro/PFSquareSansProItalic_35484.ttf")
				.default
		}) format("truetype");
    }

    @font-face {
        font-family: "PFSquareSansProLight";
        src: url(${
			require("@/assets/fonts/PFSquareSansPro/PFSquareSansProLight_35485.ttf")
				.default
		}) format("truetype");
    }

    @font-face {
        font-family: "PFSquareSansProLightItalic";
        src: url(${
			require("@/assets/fonts/PFSquareSansPro/PFSquareSansProLightItalic_35486.ttf")
				.default
		}) format("truetype");
    }

    @font-face {
        font-family: "PFSquareSansProMedium";
        src: url(${
			require("@/assets/fonts/PFSquareSansPro/PFSquareSansProMedium_35487.ttf")
				.default
		}) format("truetype");
    }

    @font-face {
        font-family: "PFSquareSansProMediumItalic";
        src: url(${
			require("@/assets/fonts/PFSquareSansPro/PFSquareSansProMediumItalic_35488.ttf")
				.default
		}) format("truetype");
    }

    @font-face {
        font-family: "PFSquareSansProRegular";
        src: url(${
			require("@/assets/fonts/PFSquareSansPro/PFSquareSansProRegular_35489.ttf")
				.default
		}) format("truetype");
    }

    @font-face {
        font-family: "PFSquareSansProThin";
        src: url(${
			require("@/assets/fonts/PFSquareSansPro/PFSquareSansProThin_35490.ttf")
				.default
		}) format("truetype");
    }

    @font-face {
        font-family: "PFSquareSansProThinItalic";
        src: url(${
			require("@/assets/fonts/PFSquareSansPro/PFSquareSansProThinItalic_35491.ttf")
				.default
		}) format("truetype");
    }

    * {
        box-sizing: border-box;
        font-family: "PFSquareSansProRegular", sans-serif;
        color: var( --auxiliary-color);
        font-size: 16px;
        line-height: 1.15;
        /* contain: content; */
    }

    html {
        max-width: 100%;
        height: 100%;
        overflow-x: hidden;
        scroll-behavior: smooth;
        /* scrollbar-color: var(--auxiliary-color) rgba(0,0,0,.5); */
        scrollbar-color: transparent transparent;
        text-size-adjust: 100%;        
    }

    body {
        max-width: 100%;
        height: 100%;
        overflow-x: hidden;
        scroll-behavior: smooth;
        
    }

    ::-webkit-scrollbar-track {
        background: rgba(0,0,0,.1);
    }

    ::-webkit-scrollbar-thumb {
        background: var(--auxiliary-color);
        border-radius: 100px;
        border: 1px solid rgba(0,0,0,.1);
    }

    ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }

    #root {
        display: flex;
        flex-direction: column;
        min-height: 100%;
    }

    main {
        flex: 1 1 100%;
        contain: initial;
        
        display: flex;
        flex-direction: column;
    }

    .text-primary {
        color: var(--primary-color) !important;
    }

    .text-secundary {
        color: var(--secundary-color) !important;
    }

    .text-auxiliary {
        color: var(--auxiliary-color) !important;
    }    

    @media screen and (min-width: 0px) {        
        .title {
            font-family: "PFSquareSansProMedium", sans-serif;
            line-height: 1.2;
            font-size: 2em;
            color: var(--auxiliary-color);
            span {
                font-family: "PFSquareSansProMedium", sans-serif;
                font-size: 1em;
                color: var(--primary-color);
            }
        }

        .center {
            display: block;
            margin: 0 auto;
        }

        .m-text-center {
            text-align: center;
        }

        .img-responsive {
            max-width: 100%;
            height: auto;
        }

        .btn-primary {
            display: block;
            background-color: var(--primary-color);
            text-decoration: none;
            text-align: center;
            color: var(--white);
            font-size: 1em;
            text-transform: uppercase;
            padding: 1em;
            width: 100%;
            max-width: 299px;
            min-width: 250px;
            border: 1px solid transparent;
            transition: all .3s;

            &:hover {
                background-color: var(--white);
                color: var(--primary-color);
                border-color: var(--primary-color);
            }
        }

        .btn-secundary {
            display: block;        
            text-decoration: none;
            text-align: center;        
            font-size: 1em;
            text-transform: uppercase;
            padding: 1em;
            width: 100%;
            max-width: 299px;
            border: 1px solid var(--primary-color);
            transition: all .3s;
            background-color: var(--white);
            color: var(--primary-color);

            &:hover {
                background-color: var(--primary-color);
                color: var(--white);
                border-color: transparent;
            }
        }    

        .button-group {
            width: max-content;
            margin: 0 auto;

            .text-separator {
                display: flex;
                align-items: center;
                column-gap: 1em;
                width: 100%;
                max-width: 299px;
                position: relative;
                text-align: center;
                margin: 5px 0;

                &::after,
                &::before {
                    content: '';
                    display: inline-block;
                    width: 100%;
                    height: 1px;
                    background-color: #D9D9D9;
                }
            }

            .small-text {
                font-size: 14px;
                margin: 5px 0;
            }
        }

        button:disabled {
            background-color: var(--light);
            border-color: var(--dark);
            color: var(--dark);
            cursor: progress;

            &:hover, &:focus, &:active {
                background-color: var(--light);
                border-color: var(--dark);
                color: var(--dark);
                cursor: progress;
            }
        }
    }

    @media screen and ( min-width: 992px ) {
        p {
            font-size: 1.125em;
            line-height: 1.444em;

            strong {
                font-size: 1em;
            }
        }

        .desktop-text-primary {
            font-family: "PFSquareSansProBold", sans-serif;
            color: var(--primary-color) !important;
        }

        .desktop-text-secundary {
            color: var(--secundary-color) !important;
        }

        .desktop-text-auxiliary {
            color: var(--auxiliary-color) !important;
        }
    }
`;
